import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Dingley – West Connection Network</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
        The West Connection Network of the Dingley Recycled Water Scheme is around 13km of the total 42km scheme. It extends west through Kingston and Bayside Local Council Areas. 
        </p>
        <p>
        Our industry partner Abergeldie, KBR, BMD Joint Venture (ABK) started construction on the West Connection Network from Black Rock in July 2025. We expect to finish construction in mid 2026.
        </p>
        <p>
        To get the job done as quickly as possible, we may have multiple crews working at the same time. We’ll let residents and businesses know before we start works in each area.
        </p>
        <p>
          For more information click{' '}
          <a
            href="https://southeastwater.com.au/residential/upgrades-and-projects/projects/dingley-recycled-water-scheme/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Dingley - Recycled Water Scheme Reticulation Networks (Stage 2)',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800330129">1800 330 129</a> |{' '}
          <a
            href="mailto:dingley@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MAIL TO: DINGLEY@SEW.COM.AU - Dingley - Recycled Water Scheme Reticulation Networks (Stage 2)',
              });
            }}
          >
            dingley@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
